import axios from "axios";
import { useQuery } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";

export const QUERY_KEY_FOR_SUGGESTED_JOBS = "talent-suggested-jobs";

const getSuggestedJobs = async (token: string) => {
    const url = `${END_POINT.BASE_URL}/v1/talent-job-suggestions`;
    const response = await axios.get(url, {
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
};

export const useTalentsSuggestedJobs = (enabled: boolean = true) => {
    const { token } = useGetUserInfo();

    return useQuery(
        [QUERY_KEY_FOR_SUGGESTED_JOBS],
        () => getSuggestedJobs(token),
        {
            enabled: !!token && enabled,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000,
        }
    );
};